import { fromJS } from 'immutable';
import { getPropsOrDefault } from '../../common/utils.jsx';

export default function setInitialDataReducer(state = {}, action = null) {
    const fields = getPropsOrDefault(action, 'response.answers.fields', {});
    if (!fields.timeStarted) {
        fields.timeStarted = new Date();
    }
    fields.timeModified = new Date();
    fields.timeSpent = 0;

    if ('string' === typeof fields.pages.currentPageIndex) {
        fields.pages.currentPageIndex = parseInt(fields.pages.currentPageIndex, 10);
    }

    if ('string' === typeof fields.pages.lastPageIndex) {
        fields.pages.lastPageIndex = parseInt(fields.pages.lastPageIndex, 10);
    }

    return fromJS(fields);
}
